<template>
  <div class="teacherSection">
    <Headline />
    <Headline2 />
    <Schedule />
    <LessonDevelopment />
    <Collaboration />
    <Templates />
    <LearningStandards />
    <SharePlans />
    <MuchMore />
    <Signup />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import Headline from '@/components/teacher/sections/Headline.vue';
import Headline2 from '@/components/teacher/sections/Headline2.vue';
import Schedule from '@/components/teacher/sections/Schedule.vue';
import LessonDevelopment from '@/components/teacher/sections/LessonDevelopment.vue';
import Collaboration from '@/components/teacher/sections/Collaboration.vue';
import Templates from '@/components/teacher/sections/Templates.vue';
import LearningStandards from '@/components/teacher/sections/LearningStandards.vue';
import SharePlans from '@/components/teacher/sections/SharePlans.vue';
import MuchMore from '@/components/teacher/sections/MuchMore.vue';
import Signup from '@/components/core/Signup.vue';

@Component({
  components: {
    Headline,
    Headline2,
    Schedule,
    LessonDevelopment,
    Collaboration,
    Templates,
    LearningStandards,
    SharePlans,
    MuchMore,
    Signup
  }
})
export default class Teacher extends Vue {
}
</script>

<style lang="scss" scoped></style>
